const bragantino = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 25/26 - Uniforme 1",
    aliases: ["bragantino", "red bull", "red bull bragantino", "2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bragantino/25-26-01/braga0.jpg",
      "/images/brasil/serie-a/bragantino/25-26-01/braga1.jpg",
      "/images/brasil/serie-a/bragantino/25-26-01/braga2.jpg",
      "/images/brasil/serie-a/bragantino/25-26-01/braga3.jpg",
      "/images/brasil/serie-a/bragantino/25-26-01/braga4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 25/26 - Uniforme 2",
    aliases: ["bragantino", "red bull", "red bull bragantino", "2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bragantino/25-26-02/braga0.jpg",
      "/images/brasil/serie-a/bragantino/25-26-02/braga1.jpg",
      "/images/brasil/serie-a/bragantino/25-26-02/braga2.jpg",
      "/images/brasil/serie-a/bragantino/25-26-02/braga3.jpg",
      "/images/brasil/serie-a/bragantino/25-26-02/braga4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 24/25 - Uniforme 1",
    aliases: ["bragantino", "red bull", "red bull bragantino", "2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bragantino/24-25-01/braga0.jpg",
      "/images/brasil/serie-a/bragantino/24-25-01/braga1.jpg",
      "/images/brasil/serie-a/bragantino/24-25-01/braga2.jpg",
      "/images/brasil/serie-a/bragantino/24-25-01/braga3.jpg",
      "/images/brasil/serie-a/bragantino/24-25-01/braga4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 24/25 - Uniforme 2",
    aliases: ["bragantino", "red bull", "red bull bragantino", "2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bragantino/24-25-02/braga0.jpg",
      "/images/brasil/serie-a/bragantino/24-25-02/braga1.jpg",
      "/images/brasil/serie-a/bragantino/24-25-02/braga2.jpg",
      "/images/brasil/serie-a/bragantino/24-25-02/braga3.jpg",
      "/images/brasil/serie-a/bragantino/24-25-02/braga4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 23/24 - Uniforme 2",
    aliases: ["bragantino", "red bull", "red bull bragantino", "2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bragantino/23-24-03/braga0.jpg",
      "/images/brasil/serie-a/bragantino/23-24-03/braga1.jpg",
      "/images/brasil/serie-a/bragantino/23-24-03/braga2.jpg",
      "/images/brasil/serie-a/bragantino/23-24-03/braga3.jpg",
      "/images/brasil/serie-a/bragantino/23-24-03/braga4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 19/20 - Uniforme 1",
    aliases: ["bragantino", "red bull", "red bull bragantino", "2019"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bragantino/19-20-01/braga0.jpg",
      "/images/brasil/serie-a/bragantino/19-20-01/braga1.jpg",
      "/images/brasil/serie-a/bragantino/19-20-01/braga2.jpg",
      "/images/brasil/serie-a/bragantino/19-20-01/braga3.jpg",
      "/images/brasil/serie-a/bragantino/19-20-01/braga4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 21/22 - Uniforme 1",
    aliases: ["bragantino", "red bull", "red bull bragantino", "2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bragantino/21-22-01/braga0.jpg",
      "/images/brasil/serie-a/bragantino/21-22-01/braga1.jpg",
      "/images/brasil/serie-a/bragantino/21-22-01/braga2.jpg",
      "/images/brasil/serie-a/bragantino/21-22-01/braga3.jpg",
      "/images/brasil/serie-a/bragantino/21-22-01/braga4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 21/22 - Uniforme 2",
    aliases: ["bragantino", "red bull", "red bull bragantino", "2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bragantino/21-22-02/braga0.jpg",
      "/images/brasil/serie-a/bragantino/21-22-02/braga1.jpg",
      "/images/brasil/serie-a/bragantino/21-22-02/braga2.jpg",
      "/images/brasil/serie-a/bragantino/21-22-02/braga3.jpg",
      "/images/brasil/serie-a/bragantino/21-22-02/braga4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 19/20 - Uniforme Edição Especial",
    aliases: ["bragantino", "red bull", "red bull bragantino"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bragantino/19-20-00-es/braga0.jpg",
      "/images/brasil/serie-a/bragantino/19-20-00-es/braga1.jpg",
      "/images/brasil/serie-a/bragantino/19-20-00-es/braga2.jpg",
      "/images/brasil/serie-a/bragantino/19-20-00-es/braga3.jpg",
      "/images/brasil/serie-a/bragantino/19-20-00-es/braga4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "bragantino",
    nome: "Bragantino 21/22 - Uniforme de Goleiro (Amarela)",
    aliases: ["bragantino", "red bull", "red bull bragantino", "2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bragantino/21-22-05-ga/braga0.jpg",
      "/images/brasil/serie-a/bragantino/21-22-05-ga/braga1.jpg",
      "/images/brasil/serie-a/bragantino/21-22-05-ga/braga2.jpg",
      "/images/brasil/serie-a/bragantino/21-22-05-ga/braga3.jpg",
      "/images/brasil/serie-a/bragantino/21-22-05-ga/braga4.jpg",
    ],
  },
];

export default bragantino;
